export default {
  selected: 'SE',
  values: [
    { value: 'SE', text: 'SE' },
    { value: 'S', text: 'S' },
    { value: 'NE', text: 'NE' },
    { value: 'N', text: 'N' }
  ]
};
